export type ResistanceBox = {
  label: string
  mOhm: number
}

export type Ba = string | number

export type CalibrationData = {
  calibration: { ba: number; frequency: number }
  resistances: ResistanceBox[]
  jumpers: string[]
}

export type RssCalibration = {
  resistances: ResistanceBox[]
}

export type DeviceRole = {
  deviceRoleCode: string
  deviceRoleName: string
}
export type DeviceRoles = {
  deviceRoles: DeviceRole[]
}

export function DeviceRoleBoxLabel(db: DeviceRole | null): string {
  return db ? `${db.deviceRoleName}` : ''
}

export function resistanceBoxLabel(rb: ResistanceBox | null): string {
  if (!rb) return ''
  return rb.mOhm > 0 ? `${rb.label} mOhm (${rb.mOhm})` : rb.label
}

export function formatBa(ba: Ba): number {
  if (typeof ba === 'number') return ba
  const parsed = Number.parseFloat(ba)
  return Number.isNaN(parsed) ? 0 : parsed
}
